module.exports = __webpack_public_path__ + "img/gb-wave-2.fbb02136.webp";